import type { ValueStatus } from "@/api";

import styles from "./StatusBadge.module.css";

const LABELS: Record<ValueStatus, string> = {
  confirmed: "Bestätigt",
  auto: "Automatisch",
  review: "Prüfen",
  conflict: "Widerspruch",
  neutral: "Unbemaßt",
};

interface StatusBadgeProps {
  status: ValueStatus;
  /** Overrides the default word when the context needs a different one. */
  children?: string;
}

/**
 * The five states of PRD §18.2. Colour alone never carries the meaning —
 * every badge also spells the state out, because the palette repeats across
 * screens and colour vision is not something to design around.
 */
export function StatusBadge({ status, children }: StatusBadgeProps) {
  return (
    <span className={`${styles.badge} ${styles[status]}`} data-status={status}>
      <span className={styles.dot} aria-hidden="true" />
      {children ?? LABELS[status]}
    </span>
  );
}

export const STATUS_LABELS = LABELS;
